/**
 * Settings for Dashboard
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Spinner from 'components/Spinner/index.jsx';
import TwoColumns from 'components/layout/TwoColumns/index.js';
import messages from './messages.js';
import useSchoolSettings from './hooks/useSchoolSettings.js';
import Details from './Details/index.jsx';
import SubSettings from './SubSettings/index.jsx';
import KeyUsers from './KeyUsers/index.jsx';
import Subschools from './Subschools.jsx';
import useIsFoundation from '../useIsFoundation.js';

function Settings(props) {
  const { setMeta } = props;
  const { settings } = useSchoolSettings();
  const isFoundation = useIsFoundation();
  useEffect(() => {
    setMeta({
      title: messages.settings,
      pageTitle: messages.settings,
    });
  }, []);
  if (settings.loading) {
    return <Spinner />;
  }
  return (
    <TwoColumns responsive>
      <div>
        <Details />
        <SubSettings />
      </div>
      <div>
        <KeyUsers />
        {isFoundation && <Subschools />}
      </div>
    </TwoColumns>
  );
}

Settings.propTypes = {
  setMeta: PropTypes.func,
};

export default Settings;
